import { isValid } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import { AppointmentFormData } from '../../types'

interface FormDataToStartDateFunction {
  (partialFormData: Partial<AppointmentFormData>): Date | null

  /**
   * @deprecated Only use in tests to mock the client's time zone
   */
  (partialFormData: Partial<AppointmentFormData>, clientTimeZone?: string): Date | null
}

const ISO_LOCALE = 'sv'
const { timeZone: browserTimeZone } = Intl.DateTimeFormat().resolvedOptions()

const formDataToStartDate: FormDataToStartDateFunction = (
  { clientStartDate, clientStartTime, customer_timezone }: Partial<AppointmentFormData>,
  clientTimeZone: string = browserTimeZone
): Date | null => {
  if (!isValid(clientStartDate) || !isValid(clientStartTime) || !customer_timezone) {
    return null
  }

  const dateFormatter = Intl.DateTimeFormat(ISO_LOCALE, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: clientTimeZone,
  }) // yyyy-MM-dd / 2022-01-22

  const timeFormatter = Intl.DateTimeFormat(ISO_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: clientTimeZone,
  }) // HH:mm / 16:00

  const [date, time] = [dateFormatter.format(clientStartDate as Date), timeFormatter.format(clientStartTime as Date)]

  // 'yyyy-MM-dd HH:mm' is the expected format for zonedTimeToUtc
  // https://github.com/marnusw/date-fns-tz#zonedtimetoutc
  const plainDateTime = `${date} ${time}`
  const actualDateTime = zonedTimeToUtc(plainDateTime, customer_timezone)

  return isValid(actualDateTime) ? actualDateTime : null
}

export { formDataToStartDate }
